/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorFeeds.defs'
export { main as default } from './getActorFeeds.defs'
